import axios from 'axios';

const apiClient = axios.create({
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

export default {
  getEvents() {
    if (process.env.NODE_ENV === 'development') {
      return apiClient.get('/events.json');
    }

    return apiClient.get('/events.php');
  },
}
